import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { IoCheckmarkCircleOutline } from "react-icons/io5";


const KeyPeople = () => {
  return (

    <section className='w-full bg-cover h-fit pb-5'>

      <Helmet>
        <title>About LMP | Key People </title>
        <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
      </Helmet>
      <BreadCrumbs />
      <div className=' w-[94%] text-justify'>
        <section className='w-full h-fit md:mx-10 mx-5 mb-1' >
          <h1 className="md:text-4xl text-lg my-1 font-semibold pt-6 uppercase text-left">Key People<br />
            <span className="text-green-600"> MIJSC</span>
          </h1>
        </section>
      </div>
      <section className="md:py-5 py-0 px-5  bg-white ">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 text-left mb-10 md:mt-0">

            <div className="flex-1">
              <div
                className="flex-[0_0_48%] min-w-[280px]"
                aria-hidden="false"
              >
                <figure className="w-full block rounded-[30px] overflow-hidden "
                  role="img" aria-label="Lecture hall at MIJSC"
                >
                  <img src="/assets/jaideep-sarkar.png" alt="MIJSC classroom and students" className="w-full h-full object-cover" />
                </figure>
              </div>
            </div>
            <div className="content-center">
              <h2 className='font-bold'>JAIDEEP SARKAR</h2>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                <p className='font-bold text-sm text-gray-600'> Professor of Practice</p>
              </div>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                <p className='font-semibold text-sm text-gray-600'> Entrepreneurship</p>
              </div>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                <p className='font-semibold text-sm text-gray-600'>Chairperson, Mizuho India Japan Study Centre @ IIMB</p>
              </div>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                <p className='font-semibold text-sm text-gray-600'> Chairperson, Israel Centre</p>
              </div>
            </div>


            <div className="flex-1">
              <div
                className="flex-[0_0_48%] min-w-[280px]"
                aria-hidden="false"
              >
                {/* Main Image */}
                <figure className="w-full block rounded-[30px] overflow-hidden"
                  role="img" aria-label="Lecture hall at MIJSC"
                >
                  <img src="/assets/saideep-rathnam.png" alt="MIJSC classroom and students" className="w-full h-full object-cover" />
                </figure>              

              </div>
            </div>
            <div className="content-center">
              <h2 className='font-bold'>DR. SAIDEEP RATHNAM</h2>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                <p className='font-bold text-sm  text-gray-600'> Advisor, Mizuho India Japan Study Centre @ IIMB</p>
              </div>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                <p className='font-semibold text-sm text-gray-600'> 50 years Industry Experience, Aero and Auto Industry</p>
              </div>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                <p className='font-semibold text-sm text-gray-600'>Founder and Chief Instructor – VLCI</p>
              </div>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                <p className='font-semibold text-sm text-gray-600'> Creator and Director of Lean Manufacturing Practices Program @ MIJSC </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </section>
  )
}

export default KeyPeople
